export const environment = {
  production: false,
  hostUrl: 'https://dev-kp-mm.vthgdigital.com',
  apiUrl: 'https://dev-kp-mm.vthgdigital.com/api/',
};
